import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { FetchImageFromBackoffice } from "../../utils/requests";
import { Box } from "@mui/material";
import { Colors, Styles } from "../../constants/theme";


export const VehicleImage = ({ blobId, vehicleVin, onDone }: { blobId?: string, vehicleVin: string | undefined, onDone?: (url?: string) => void }) => {
  const [imageURL, setImageURL] = useState<string>();
  const [error, setError] = useState(false);
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    if (!blobId || !vehicleVin) {
      onDoneRef.current?.();
      return;
    }

    let cancelled = false;

    const fetchImage = async () => {
      try {
        const blob = await FetchImageFromBackoffice<Blob>(
          `portal/files/${vehicleVin}/files/${blobId}`
        );
        if (cancelled) return;
        const url = URL.createObjectURL(blob);
        setImageURL(url);
        onDoneRef.current?.(url);
      } catch (err) {
        if (cancelled) return;
        setError(true);
        console.warn("Image fetch failed:", err);
        onDoneRef.current?.();
      }
    };

    fetchImage();

    return () => {
      cancelled = true;
    };
  }, [blobId, vehicleVin]);

  return (
    <Box sx={
      {
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        borderTopLeftRadius: `${Styles.BorderRadius}px`,
        borderTopRightRadius: `${Styles.BorderRadius}px`,
        backgroundColor: error ? Colors.light.lightGrey : 'transparent'
      }}>
      <Box
        sx={{ width: "100%" }}
      >
        <img
          src={imageURL}
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "cover", }}
        />

      </Box>

    </Box >
  );
};
